import { getCompanyByCompanyId } from "@/apis"
import { COMPANY_SENDING_REQUEST, COMPANY_DETAIL_SUCCESS, COMPANY_REQUEST_FAIL } from "../action-types/company"

// eslint-disable-next-line import/prefer-default-export
export const getCompanyByCompanyIdAction = (companyId) => async (dispatch) => {
    dispatch({ type: COMPANY_SENDING_REQUEST })
    try {
        const result = await getCompanyByCompanyId(companyId)
        const companyDetail = result.data
        dispatch({
            type: COMPANY_DETAIL_SUCCESS,
            payload: companyDetail,
        })
    } catch (error) {
        dispatch({ type: COMPANY_REQUEST_FAIL, payload: { message: error } })
    }
}
